<ng-container *ngIf="mainForm !== undefined">
  <div *ngIf="_options" [formGroup]="mainForm" class="dropdown-container">
    <app-popover
      *ngIf="invalidValueToShow && invalidValueText"
      [text]="(invalidValueText | translate)"
      [size]="'small'"
      [showPopover]="true"
      (popoverClosed)="onClosePopover($event)"
    ></app-popover>
    <ng-select
      #select
      class="{{layoutModifier}}"
      [ngClass]="{
        'ng-select-highlighted': (!state && highlight),
        'dropdown-updated': state === 'updated',
        'dropdown-error': state === 'error',
        'dropdown-required': state === 'required',
        'dropdown-new': state === 'new'
      }"
      [searchable]="searchable"
      [multiple]="multiple"
      [clearable]="clearable && !customClearIcon"
      [clearOnBackspace]="clearOnBackspace"
      [formControlName]="controlName"
      [maxSelectedItems]="maxSelectedItems"
      [dropdownPosition]="dropdownPosition"
      [notFoundText]="('GENERAL.NO_RESULTS_SHORT' | translate)"
      [placeholder]="placeholder ? (placeholder | translate) : ('FORMS.COMMON.PLEASE_SELECT' | translate) + '...'"
      [clearAllText]="clearAllLabel ? (clearAllLabel | translate) : ('FORMS.COMMON.CLEAR_ALL' | translate)"
      (add)="onAddEvent($event)"
      (remove)="onRemoveEvent($event)"
      (open)="onOpenEvent()"
      (close)="onCloseEvent()"
      (clear)="onClearEvent()"
    >
      <ng-template ng-header-tmp *ngIf="placeholderSearch">
        <form [formGroup]="searchForm">
          <input #search type="text" [placeholder]="(placeholderSearch | translate)" [formControlName]="'search'"
            (keydown)="searchOnKeydown($event)" (keyup.enter)="searchOnEnter()">
        </form>
      </ng-template>
      <ng-template ng-label-tmp *ngIf="prefix || suffix || invalidValueToShow">
        <span class="label-tmp" [ngClass]="{'label-tmp_invalid': invalidValueToShow}">
          <span class="label-tmpPrefix" *ngIf="prefix">{{prefix}}</span>
          <span class="label-tmpText" [ngClass]="{'label-tmpText_right': prefix && suffix}">
            {{ invalidValueToShow || controlNameInputValue || mainForm.controls[controlName].value }}
          </span>
          <span class="label-tmpSuffix" *ngIf="suffix">{{suffix}}</span>
        </span>
      </ng-template>
      <ng-container *ngFor="let o of _options">
        <ng-option
          *ngIf="!hideIncompatibleValues || !disabledKey || (hideIncompatibleValues && disabledKey && !o[disabledKey])"
          [value]="valueKey ? o[valueKey] : o" [disabled]="!allowDisabledSelection && disabledKey && o[disabledKey]">
          <ng-container *ngIf="labelKey && o[labelKey]">
            <span [ngClass]="{
              'extern-object-icon': o.createdByManufacturer,
              'ng-option_disabled': allowDisabledSelection && disabledKey && o[disabledKey],
              'ng-option_default': o.assigned === 'BY_DEFAULT'}">
              <i *ngIf="o.createdByManufacturer"><img src="assets/common/icons/extern-white.svg"></i>
              <ng-container
                *ngIf="control?.value === o[labelKey] && controlNameInputValue !== '' && controlNameInputValue != o[labelKey], else showControlInputValue">
                {{controlNameInputValue}}
              </ng-container>
              <ng-template #showControlInputValue>
                {{o[labelKey] | translate}}
              </ng-template>
            </span>
          </ng-container>
        </ng-option>
      </ng-container>
    </ng-select>
    <app-form-errors [control]="control"></app-form-errors>
    <app-tooltip
      *ngIf="clearable && customClearIcon" [hasTooltip]="mainForm.status !== 'DISABLED'" [text]="clearAllLabel ? (clearAllLabel | translate) : ('FORMS.COMMON.CLEAR_ALL' | translate)">
      <i svgIcon [ngClass]="{'icon_disabled' : mainForm.status === 'DISABLED'}" [icon]="'close_circle'" [iconSize]="svgIconSizeMod.EXTRA_SMALL" (click)="onClearEvent()"></i>
    </app-tooltip>
  </div>
</ng-container>
